import React, {useState, useContext, useEffect} from 'react'
import TextFields_Outlined from '../TextFields_Outlined';

/* FX */
import FadeIn from '../FadeIn'

/* */
import {TranslationColumn1Context} from '../TranslationContexts/TranslationColumn1Context'

/* Bootstrap */
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import 'bootstrap/dist/css/bootstrap.min.css';

const TranslationContent_Transcript = ({triggerUpdateFromParent, required, updateProgressBar, valueInField, classesToAdd}) => {
    const { col1RequiredFields, setCol1RequiredFields } = useContext(TranslationColumn1Context)

    // For unmounting
    useEffect(() => {
        return;
        var temp = col1RequiredFields;
        temp.transcriptText = "";
        setCol1RequiredFields(temp)
        // We also need to re-run the progress bar becaues there's been an update
        updateProgressBar()
      // returned function will be called on component unmount 
      return () => {
        var temp = col1RequiredFields;
        delete temp.transcriptText;
        setCol1RequiredFields(temp)
        // We also need to re-run the progress bar becaues there's been an update
        updateProgressBar()
      }
    }, [])
    
    function triggerUpdateInParent(id, value ){
        triggerUpdateFromParent(id, value)
        return;
        var temp = col1RequiredFields;
        setCol1RequiredFields(temp)
        triggerUpdateFromParent(id, value)
    }

    return (
        <FadeIn delay={0} duration={350}>
            <Row>
                <Col style={{textAlign:'center'}}>
                    <TextFields_Outlined valueInField={valueInField} classesToAdd={classesToAdd} required={required} triggerUpdateInParent={triggerUpdateInParent} id="transcriptText" label="Transcript - Student Name"/>
                </Col>
            </Row>
        </FadeIn>
    )
}

export default TranslationContent_Transcript
